var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportingBtnIconImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 6.17223V4.53125C14.5312 3.66832 13.8317 2.96875 12.9688 2.96875H8.28125L7.17641 1.86391C6.88336 1.57086 6.48594 1.40625 6.07152 1.40625H2.34375C1.48082 1.40625 0.78125 2.10582 0.78125 2.96875V12.3438C0.78125 13.2067 1.48082 13.9062 2.34375 13.9062H5.51531",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 18.5938V16.25C19.2188 13.6612 17.1201 11.5625 14.5312 11.5625H12.9688V10C12.9688 9.56852 12.619 9.21875 12.1875 9.21875C11.9718 9.21875 11.7765 9.30621 11.635 9.44758L8.51004 12.5726C8.36871 12.7139 8.28125 12.9093 8.28125 13.125C8.28125 13.3407 8.36871 13.5361 8.51004 13.6774L11.635 16.8024C11.7765 16.9438 11.9718 17.0312 12.1875 17.0312C12.619 17.0312 12.9688 16.6815 12.9688 16.25V14.6875H16.0938C17.8196 14.6875 19.2188 16.0866 19.2188 17.8125",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportingBtnIconImport);
export default __webpack_public_path__ + "static/media/importingBtnIconImport.a942b6b62a5005a6c9b505e2929c6169.svg";
export { ForwardRef as ReactComponent };